// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__zByqY","Button-primary":"Button_Button-primary__lxfmE","Button-secondary":"Button_Button-secondary__R2VRY"};